import * as Types from './qualityCheckActionTypes.js'

const initialState = {
    qualityCheckTypes: [],
    qualityChecks: [],
    qualityCheckOrders: [],
};

export default function order(state = initialState, action) {
    switch (action.type) {
        case Types.SET_QUALITYCHECKTYPES:
            if (state.qualityCheckTypes !== action.qualityCheckTypes) {
                return Object.assign({}, state, { qualityCheckTypes: action.qualityCheckTypes });
            }
            return state;
        case Types.SET_QUALITYCHECKS:
            if (state.qualityChecks !== action.qualityChecks) {
                return Object.assign({}, state, { qualityChecks: action.qualityChecks });
            }
            return state;
        case Types.SET_QUALITYCHECKORDERS:
            if (state.qualityCheckOrders !== action.qualityCheckOrders) {
                return Object.assign({}, state, { qualityCheckOrders: action.qualityCheckOrders });
            }
            return state;
        default:
            return state;
    }
}